import { render, staticRenderFns } from "./NotificationPage.vue?vue&type=template&id=5f0adc22&scoped=true&"
import script from "./NotificationPage.vue?vue&type=script&lang=js&"
export * from "./NotificationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0adc22",
  null
  
)

export default component.exports